<template>
    <el-dropdown placement="bottom-end" trigger="click" popper-class="language-popper">
      <div class="flex flex-row items-center gap-1 md:gap-2 mb-1">
        <div class="pt-1">
          <el-link :underline="false">
            
          </el-link>
        </div>
        <div class="">
          <h4>
            <el-link
              :underline="false"
              class="text-sm font-semibold text-slate-50 hover:text-slate-300 pt-1"
              >
                <img
                  :src="currentFlag"
                  class="w-7 h-7 rounded-full"
                  alt="flag"/>
              </el-link
            >
          </h4>
        </div>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item class="m-0 hover:bg-white">
            <div class="flex items-center w-full pt-1 cursor-default">
              <h5 class="truncate m-0 text-primary-dark">{{ currentChangeLang }}</h5>
            </div>
          </el-dropdown-item>
  
          <el-dropdown-item
            v-for="lang in languages"
            :key="lang.code"
            class="mx-0 my-2 hover:bg-slate-100 text-zinc-800"
          >
            <div @click="setLangDefault(lang.code)" class="flex flex-row items-center w-full h-6">
              <div class="flex w-auto">
                <el-icon :size="22" class="cursor-pointer w-5 h-6">
                  <img :src="lang.flag" class="w-5 h-5 rounded-full" :alt="lang.label" />
                </el-icon>
              </div>
              <div class="ml-4">
                <span class="mb-0 text-sm font-normal">{{ lang.label }}</span>
              </div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </template>
  
  <script lang="ts">
  import { defineComponent, computed } from 'vue'
  import { useState } from 'modules/auth/store/state'
  import { useI18n } from 'vue-i18n'
  import { changeLang } from '@/i18n'
  import dayjs from 'dayjs'
  import EN_FLAG from '@/assets/flags/en.png'
  import DE_FLAG from '@/assets/flags/de.png'
  import ES_FLAG from '@/assets/flags/es.png'
  import FR_FLAG from '@/assets/flags/fr.png'
  import IT_FLAG from '@/assets/flags/it.png'
  import JP_FLAG from '@/assets/flags/jp.png'
  import PT_FLAG from '@/assets/flags/pt.png'
  import RU_FLAG from '@/assets/flags/ru.png'
  import SV_FLAG from '@/assets/flags/sv.png'
  
  export default defineComponent({
    name: 'LanguageDropdown',
    setup() {
      const { locale, t } = useI18n()
      const authState = useState()
  
      const languages = [
        { code: 'it', label: 'Italiano', flag: IT_FLAG },
        { code: 'en', label: 'English', flag: EN_FLAG },
        { code: 'de', label: 'Deutsch', flag: DE_FLAG },
        { code: 'es', label: 'Español', flag: ES_FLAG },
        { code: 'fr', label: 'Français', flag: FR_FLAG },
        //{ code: 'jp', label: '日本語', flag: JP_FLAG },
        { code: 'pt', label: 'Português', flag: PT_FLAG },
        { code: 'ru', label: 'Русский', flag: RU_FLAG },
        { code: 'sv', label: 'Svenska', flag: SV_FLAG },
      ]
  
      const currentFlag = computed(() => {
        return languages.find((l) => l.code === locale.value)?.flag || EN_FLAG
      })
  
      const currentChangeLang = t('Edit Language')
  
      const setLangDefault = (lang: string) => {
        locale.value = lang
        changeLang(lang)
        authState.setSetting({ setting: { locale: lang } })
        location.reload()
      }
  
      return {
        languages,
        currentFlag,
        currentChangeLang,
        setLangDefault,
      }
    },
  })
  </script>
  